// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Reviews } = initSchema(schema);

export {
  Reviews
};